export enum FavoriteCategories {
  SEARCHES = 'recherches enregistrées',
  OFFERS = 'offres enregistrées',
  RECENTS = 'recherches récentes',
}
